
import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'Button',

  props: {
    label: {
      type: String,
      default: 'ボタンラベル'
    },
    emlabel: {
      type: String,
      default: ''
    },
    labelInner: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      require: false
    },
    blank: {
      type: Boolean,
      require: false
    },
    wide: {
      type: Boolean,
      default: false
    },
    wide303: {
      type: Boolean,
      default: false
    },
    primary: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    thingray: {
      type: Boolean,
      default: false
    },
    lightgray: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    favorite: {
      type: Boolean,
      default: false
    },
    line: {
      type: Boolean,
      default: false
    },
    facebook: {
      type: Boolean,
      default: false
    },
    google: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    sizeS: {
      type: Boolean,
      default: false
    },
    sizeLow: {
      type: Boolean,
      default: false
    },
    radiusS: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Boolean,
      default: false
    },

    handleClick: Function
  },

  setup(props) {
    const classObject = computed(() => {
      const {
        wide,
        primary,
        secondary,
        thingray,
        lightgray,
        border,
        favorite,
        line,
        facebook,
        google,
        disabled,
        sizeS,
        sizeLow,
        radiusS,
        zoom,
        wide303
      } = props
      return {
        button: true,
        wide,
        primary,
        secondary,
        thingray,
        lightgray,
        border,
        favorite,
        line,
        facebook,
        google,
        disabled,
        sizeS,
        sizeLow,
        radiusS,
        zoom,
        wide303
      }
    })

    const clickA = (e: any) => {
      if (props.blank) return true
      if (e.ctrlKey || e.metaKey) return true

      e.preventDefault()
      if (props.handleClick) return props.handleClick()
    }

    return {
      clickA,
      classObject
    }
  }
})
